class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);

      // Sync timer UI after drawer content re-renders
      if (timeInSeconds > 0) {
        syncTimerUI();
      }
      
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);

        // Sync timer UI after drawer content re-renders
        if (timeInSeconds > 0) {
          syncTimerUI();
        }
        
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');

    // Sync timer UI after drawer content re-renders
    if (timeInSeconds > 0) {
      syncTimerUI();
    }
    
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();

      // Sync timer UI after drawer content re-renders
      if (timeInSeconds > 0) {
        syncTimerUI();
      }

      // Sync freebie after drawer content re-renders
      freebieUpdate();
      
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

//----cart timer code starts----//
let countdownInterval;
let timeInSeconds = 0; // Global timer state
let timerMessageEl = document.querySelector('.cstm_drawer_header_timer_msg');
let timerMessageEl_time = document.querySelector('.cstm_drawer_header_timer .timer_msg_expire_time');
const addToCartButtons = document.querySelectorAll('.cstm_add_to_cart');
const expireTime = parseInt(timerMessageEl?.dataset.expireTime, 10) || 0;
// Restore previous state
const savedTime = parseInt(localStorage.getItem('timeInSeconds'), 10);
const savedMessage = localStorage.getItem('timerMessage');
const consentData = JSON.parse(localStorage.getItem('cookieConsent'));
// Show saved message and resume timer if valid
if (timerMessageEl) {
  if (savedMessage) {
    timerMessageEl.textContent = savedMessage;
    timerMessageEl.style.display = 'block';
  }
  if (!isNaN(savedTime) && savedTime > 0 && consentData && Date.now() < consentData.expiresAt) {
    timeInSeconds = savedTime;
    syncTimerUI();
    startCountdown();
  }
}
// Funcation to update timer text and save to localStorage
function syncTimerUI() {
  timerMessageEl = document.querySelector('.cstm_drawer_header_timer_msg'); // Re-select in case the drawer is rendered after click
  timerMessageEl_time = document.querySelector('.cstm_drawer_header_timer .timer_msg_expire_time'); // Re-select in case the drawer is rendered after click
  if (!timerMessageEl) return;
  timerMessageEl.style.display = 'block';
  const consent = JSON.parse(localStorage.getItem('cookieConsent'));
  if (!consent || Date.now() >= consent.expiresAt || timeInSeconds <= 0) {
    const expiredMsg = "Your cart has expired.";
    const expiredTimeInSeconds = 0;
    timerMessageEl.textContent = expiredMsg;
    localStorage.setItem('timerMessage', expiredMsg);
    localStorage.setItem('timeInSeconds', expiredTimeInSeconds);
    timerMessageEl_time.style.display = 'none';
    return;
  }
  const minutes = Math.floor(timeInSeconds / 60);
  const seconds = timeInSeconds % 60;
  let time = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')} mins.`;
  // const msg = `Hurry now! Your cart will expire in ${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')} mins.`;
  const msg = `Hurry now! Your cart will expire in `;
  timerMessageEl.textContent = msg;
  // localStorage.setItem('timerMessage', msg);
  timerMessageEl_time.textContent = time;
  localStorage.setItem('timerMessage', time);
}
// Function to start countdown ticking
function startCountdown() {
  if (countdownInterval) clearInterval(countdownInterval);
  countdownInterval = setInterval(() => {
    if (timeInSeconds > 0) {
      timeInSeconds--;
      localStorage.setItem('timeInSeconds', timeInSeconds);
    }
    syncTimerUI();
    if (timeInSeconds <= 0) clearInterval(countdownInterval);
  }, 1000);
}
// Start timer on .cstm_add_to_cart click
if (timerMessageEl && addToCartButtons.length && expireTime > 0) {
  addToCartButtons.forEach(button => {
    button.addEventListener('click', () => {
      const expiresAt = Date.now() + (30 * 24 * 60 * 60 * 1000); // 30 days
      localStorage.setItem('cookieConsent', JSON.stringify({
        accepted: true
        , expiresAt
      }));
      if (timeInSeconds <= 0) {
        timeInSeconds = expireTime * 60;
        localStorage.setItem('timeInSeconds', timeInSeconds);
      }
      syncTimerUI(); // Show message immediately
      startCountdown(); // Start countdown ticking
      setTimeout(syncTimerUI, 300); // Optionally re-apply after small delay if drawer opens dynamically
    });
  });
} else {
  console.log('Required elements not found or invalid expire time.');
}
//----cart timer code ends----//

/*-------cart freebie product add code starts------*/ 
function freebieUpdate() {
  console.log("freebieUpdate function call");
  // addFreebie();
  // add_PO3_Freebie();
  // add_novology_freebie();
  update_Cart_weight()
}

const cstmCartDrawerWrapper = document.getElementById('CartDrawer');


// <!--------------------New-freebie-code-for-select-your-favorite-flavor-start--------------------------------------->

//----May Summer Sale Freebie Code Starts Here-----//

const PACK_OF_6_STORAGE_KEY = 'selected_pack_of_6';

// PURANE FREEBIES & OLD PACK OF 7 (Cart se remove karne ke liye)
const OLD_GIFT_IDS = [
  48387167092990, // Organizer Variant ID
  48510786470142, // Purana Pack of 7 - RASPBERRY MELON
  48510774706430  // Purana Pack of 7 - JUICY PEACH
];

// 1. Candidate Variant IDs for LIV Gift / Box 1 (Primary -> Fallback)
const free_gift_box_1_candidates = [
  // 48132664918270, // Primary: Keychain (0 Stock hone par skip hoga)
  // 47457065173246  // Fallback: Fridge Magnet change into festival kit.
];

const free_gift_box_2 = 48693488419070; // Cap
const free_gift_box_3 = 48693491859710; // Felt Bag

// Pack of 6 Candidate Variants (Choose 2 out of 3)
const free_gift_box_4 = [
  48693415117054, // Lemon Lime
  48693408432382, // Brazilian Orange
  48693416624382  // Acai Berry
];

// Default 2 Flavors Selection
const DEFAULT_SELECTION = [48693415117054, 48693408432382];

// Cache for stock checks
const stockCheckCache = {};

// ⚡ Accurate Live Stock Checker (Direct Variant ID Based - No Handle Dependency)
async function isVariantAvailableById(variantId) {
  const vid = Number(variantId);
  if (stockCheckCache[vid] !== undefined) {
    return stockCheckCache[vid];
  }

  try {
    const res = await fetch(`/search/suggest.json?q=${vid}&resources[type]=product&t=${Date.now()}`);
    if (!res.ok) {
      stockCheckCache[vid] = false;
      return false;
    }
    const data = await res.json();
    const products = data.resources?.results?.products || [];
    let isAvailable = false;

    for (const prod of products) {
      if (prod.variants) {
        const v = prod.variants.find(item => Number(item.id) === vid);
        if (v && v.available === true) {
          isAvailable = true;
          break;
        }
      }
    }

    stockCheckCache[vid] = isAvailable;
    return isAvailable;
  } catch (err) {
    console.error('Stock check error for variant ' + vid, err);
    stockCheckCache[vid] = false;
    return false;
  }
}

// // ⚡ Auto-Resolve Box 1 In-Stock Variant (Keychain -> Magnet)
// async function getInStockBox1Candidate() {
//   for (const variantId of free_gift_box_1_candidates) {
//     const isAvailable = await isVariantAvailableById(variantId);
//     if (isAvailable) {
//       return variantId; // Returns Keychain if in-stock, else Fridge Magnet
//     }
//   }
//   // Agar dono OOS ho to fallback last candidate
//   return free_gift_box_1_candidates[free_gift_box_1_candidates.length - 1];
// }

// Helper: Get Pack of 6 Selection
function getStoredPackOf6Selection() {
  try {
    const raw = localStorage.getItem(PACK_OF_6_STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed) && parsed.length === 2) {
        const validIds = parsed.map(Number).filter(id => free_gift_box_4.includes(id));
        if (validIds.length === 2 && validIds[0] !== validIds[1]) {
          return validIds;
        }
      }
    }
  } catch (err) {
    console.error('Error reading Pack of 6 selection:', err);
  }
  localStorage.setItem(PACK_OF_6_STORAGE_KEY, JSON.stringify(DEFAULT_SELECTION));
  return [...DEFAULT_SELECTION];
}

// Helper: Update Cart Drawer HTML Section
async function updateCartSection() {
  const currentCart = document.querySelector('#CartDrawer');
  if (!currentCart) return;
  const cartUrl = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
  const url = `${cartUrl}?section_id=cart-drawer&t=${Date.now()}`;
  
  try {
    const response = await fetch(url);
    const responseText = await response.text();
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const updatedCart = html.querySelector('#CartDrawer');
    const cartWrapper = document.querySelector('.cstm_cart_drawer_wrapper');
    const cartbubble = document.querySelector('.cart-count-bubble');

    if (updatedCart && currentCart) {
      currentCart.innerHTML = updatedCart.innerHTML;
      
      const isCartEmpty = updatedCart.innerText.includes('Your cart is empty');
      if (isCartEmpty) {
        cartWrapper?.classList.add('is-empty');
        if (cartbubble) {
          cartbubble.style.display = 'none';
          cartbubble.innerText = '';
        }
      } else {
        cartWrapper?.classList.remove('is-empty');
        const updatedCount = html.querySelector('[data-cart-count]');
        if (updatedCount && cartbubble) {
          const count = parseInt(updatedCount.getAttribute('data-cart-count')) || 0;
          if (count > 0) {
            cartbubble.innerText = count;
            cartbubble.style.display = 'flex';
          } else {
            cartbubble.style.display = 'none';
            cartbubble.innerText = '';
          }
        }
      }
    }
  } catch (error) {
    console.error('Error updating cart section:', error);
  }
}

// Option Click Event Listener (2-of-3 Selection System for Pack of 6)
document.addEventListener('click', async function (event) {
  const option = event.target.closest('.pack-of-6-option');
  if (!option) return;

  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();

  const clickedVariantId = Number(option.dataset.variantId);
  if (!free_gift_box_4.includes(clickedVariantId)) return;

  let currentSelected = getStoredPackOf6Selection();
  let newSelected;

  if (currentSelected.includes(clickedVariantId)) {
    const unselectedId = free_gift_box_4.find(id => !currentSelected.includes(id));
    newSelected = [currentSelected.find(id => id !== clickedVariantId), unselectedId];
  } else {
    newSelected = [currentSelected[0], clickedVariantId];
  }

  localStorage.setItem(PACK_OF_6_STORAGE_KEY, JSON.stringify(newSelected));

  if (typeof window.update_Cart_weight === 'function') {
    await window.update_Cart_weight();
  }
}, true);

let isUpdatingCart = false;

window.update_Cart_weight = async function () {
  if (isUpdatingCart) return;
  isUpdatingCart = true;

  const cstmCartDrawerWrapper = document.getElementById('CartDrawer');
  cstmCartDrawerWrapper?.classList.add('cart-items-disabled');

  try {
    const res = await fetch('/cart.json?t=' + Date.now());
    if (!res.ok) throw new Error('Unable to fetch cart');
    const data = await res.json();

    // // ⚡ Auto-Detect In-Stock Candidate for Box 1
    // const active_box_1_id = await getInStockBox1Candidate();

    const allKnownGiftIds = [
      // ...free_gift_box_1_candidates,
      free_gift_box_2,
      free_gift_box_3,
      ...free_gift_box_4,
      ...OLD_GIFT_IDS
    ];

    // Separate Paid Items & Gift Items
    const paidItems = data.items.filter(
      (item) => !allKnownGiftIds.includes(item.id) && item.properties?.free_gift === undefined
    );
    const giftItemsInCart = data.items.filter(
      (item) => allKnownGiftIds.includes(item.id) || item.properties?.free_gift !== undefined
    );

    // 1. Clear cart if ONLY freebies remain
    if (data.items.length > 0 && paidItems.length === 0) {
      await fetch('/cart/clear.js', { method: 'POST' });
      await updateCartSection();
      return;
    }

    // 2. Calculate Cart Total (Bundle-Safe)
    let paidTotalCents = paidItems.reduce(
      (sum, item) => sum + (item.final_line_price || item.line_price || 0),
      0
    );
    const cartTotal = paidTotalCents > 0 ? (paidTotalCents / 100) : (data.total_price / 100);

    // 3. Determine Tier Eligibility
    let eligibleGiftIds = [];

    if (cartTotal >= 3500) {
      const selectedPackOf6 = getStoredPackOf6Selection();
      eligibleGiftIds = [free_gift_box_2, free_gift_box_3, ...selectedPackOf6];
    } else if (cartTotal >= 2900) {
      eligibleGiftIds = [ free_gift_box_2, free_gift_box_3];
    } else if (cartTotal >= 1499) {
      eligibleGiftIds = [ free_gift_box_2];
    // } else if (cartTotal > 0) {
    //   eligibleGiftIds = [active_box_1_id];
    } else {
      eligibleGiftIds = [];
    }

    // 4. Audit Cart: Ineligible, OOS Keychain, ya Old Gifts ko remove karo
    const updates = {};
    const processedEligibleGifts = new Set();
    let hasRemovals = false;

    for (const item of giftItemsInCart) {
      // Check if this item is currently in our eligible list
      if (
        eligibleGiftIds.includes(item.id) &&
        !processedEligibleGifts.has(item.id) &&
        item.quantity === 1
      ) {
        processedEligibleGifts.add(item.id);
      } else {
        // OOS Keychain, Purana Pack of 7, ya Ineligible gifts remove honge
        updates[item.key] = 0;
        hasRemovals = true;
      }
    }

    // Execute Batch Removals
    if (hasRemovals) {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates })
      });
    }

    // 5. Add Missing In-Stock Gifts
    const itemsToAdd = [];
    for (const giftId of eligibleGiftIds) {
      if (!processedEligibleGifts.has(giftId)) {
        itemsToAdd.push({
          id: Number(giftId),
          quantity: 1,
          properties: { free_gift: 'freebie' }
        });
      }
    }

    // ⚡ Execute Batch Add (Fridge Magnet + Cap + Felt Bag + Flavors in 1 Single Request)
    if (itemsToAdd.length > 0) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: itemsToAdd })
      });
    }

    // Refresh Cart Drawer
    if (hasRemovals || itemsToAdd.length > 0) {
      await updateCartSection();
    }

  } catch (error) {
    console.error('Error updating cart freebies:', error);
  } finally {
    cstmCartDrawerWrapper?.classList.remove('cart-items-disabled');
    isUpdatingCart = false;
  }
};

// ⚡ GLOBAL CART LISTENER
(function() {
  if (window._freebieListenerAttached) return;
  window._freebieListenerAttached = true;

  let debounceTimer = null;
  const originalFetch = window.fetch;
  
  window.fetch = async function() {
    const response = await originalFetch.apply(this, arguments);
    const url = arguments[0];
    
    if (
      typeof url === 'string' &&
      !isUpdatingCart &&
      (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/clear') || url.includes('/cart/update'))
    ) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        if (typeof window.update_Cart_weight === 'function') {
          window.update_Cart_weight();
        }
      }, 50);
    }
    return response;
  };

  document.addEventListener('DOMContentLoaded', () => {
    if (typeof window.update_Cart_weight === 'function') {
      window.update_Cart_weight();
    }
  });
})();

//----May Summer Sale Freebie Code Ends Here-----//
